import LTR from "@brand-icons/ploom/chevron-up/chevron-up-ltr.svg";

import { iconFactory } from "../iconFactory";

export const ChevronUpIcon = iconFactory("ChevronUpIcon", LTR);
